module.exports = "/images/vendor/flag-icon-css/flags/4x3/dm.svg?46f58d408f6a338114dbd063b87f97f7";